import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { settings } from '../../../settings';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  api = settings.API_URL;

  constructor(private http: HttpClient) {}

  companyDetailsSubmitService(params: any, sessionHash: string) {
    return this.http.post(
      this.api + `/api/companyInfo?sessionHash=${sessionHash}`,
      params.params,
      { responseType: 'text' },
    );
  }

  companyEditSubmitService(params: any, sessionHash: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json-patch+json',
      Accept: 'text/plain',
    });
    return this.http.put(
      this.api +
        `/api/companyInfo?sessionHash=${sessionHash}&companyName=${params.params.companyName}`,
      params.params,
      { headers, responseType: 'text' as 'json' },
    );
  }

  getCompanyDetails(sessionHash: string) {
    const headers = new HttpHeaders({
      responseType: 'text',
    });
    return this.http.get(
      this.api + `/api/companyInfo?sessionHash=${sessionHash}`,
      { headers },
    );
  }

  getOwnerCities(params: any) {
    return this.http.get(this.api + `/api/ownerCities`, params);
  }

  getContactDetails(sessionHash: string) {
    const headers = new HttpHeaders({
      responseType: 'text',
    });
    return this.http.get(
      this.api + `/api/contacts?sessionHash=${sessionHash}`,
      { headers },
    );
  }

  addContacts(params: any, sessionHash: string) {
    const headers = new HttpHeaders({
      accept: 'text/plain',
      'Content-Type': 'application/json-patch+json',
    });
    return this.http.post(
      this.api + `/api/contacts?sessionHash=${sessionHash}`,
      params.params,
      { headers, responseType: 'text' as 'json' },
    );
  }

  editContactsService(params: any) {
    return this.http.put(
      this.api + `/api/contacts?sessionHash=${params.params.sessionHash}`,
      params.params,
      { responseType: 'text' },
    );
  }

  deleteContactsService(params: any, contactId: number) {
    const options = {
      params: params,
      responseType: 'text' as 'json',
    };
    return this.http.delete(this.api + `/api/contacts/${contactId}`, options);
  }

  getAddressService(sessionHash: string) {
    const headers = new HttpHeaders({
      responseType: 'text',
    });
    return this.http.get(
      this.api + `/api/addresses?sessionHash=${sessionHash}`,
      { headers },
    );
  }

  addAddressService(params: any, sessionHash: string) {
    const headers = new HttpHeaders({
      responseType: 'text',
      'Content-Type': 'application/json-patch+json',
    });
    return this.http.post(
      this.api + `/api/addresses?sessionHash=${sessionHash}`,
      params.params,
      { headers },
    );
  }

  editAddressService(params: any) {
    return this.http.put(
      this.api +
        `/api/addresses/${params.params.addressId}?sessionHash=${params.params.sessionHash}`,
      params.params,
      { responseType: 'text' },
    );
  }

  deleteAddressService(params: any, addressId: number) {
    return this.http.delete(this.api + `/api/addresses/${addressId}`, {
      params: params,
      responseType: 'text',
    });
  }

  getCommentsService(sessionHash: string) {
    const headers = new HttpHeaders({
      responseType: 'text',
    });
    return this.http.get(
      this.api + `/api/comments/all?sessionHash=${sessionHash}`,
      { headers },
    );
  }

  markCommentAsViewed(params: any) {
    return this.http.put(
      this.api +
        `/api/comments/markAsViewed?sessionHash=${params.sessionHash}&commentId=${params.commentId}`,
      params,
      { responseType: 'text' },
    );
  }

  getUnviewedCountService(sessionHash: string) {
    const headers = new HttpHeaders({
      responseType: 'text',
    });
    return this.http.get(
      this.api + `/api/comments/unviewedCount?sessionHash=${sessionHash}`,
      { headers },
    );
  }

  getCityPermitDetails(sessionHash: string, permitId: number) {
    const headers = new HttpHeaders({
      responseType: 'text',
    });
    return this.http.get(
      this.api +
        `/api/cityPermits?sessionHash=${sessionHash}&permitId=${permitId}`,
      { headers },
    );
  }

  addCityPermitsService(params: any, sessionHash: string) {
    const headers = new HttpHeaders({
      responseType: 'text',
      'Content-Type': 'application/json-patch+json',
    });
    return this.http.post(
      this.api + `/api/cityPermits?sessionHash=${sessionHash}`,
      params.params,
      { headers },
    );
  }

  editCityPermitsService(params: any) {
    return this.http.put(
      this.api + `/api/cityPermits?sessionHash=${params.params.sessionHash}`,
      params.params,
      { responseType: 'text' },
    );
  }

  deleteCityPermitsService(params: any, cityPermitId: number) {
    return this.http.delete(this.api + `/api/cityPermits/${cityPermitId}`, {
      params: params,
      responseType: 'text',
    });
  }

  getInsurancePolicyDetails(sessionHash: string, permitId: number) {
    const headers = new HttpHeaders({
      responseType: 'text',
    });
    return this.http.get(
      this.api +
        `/api/insurancePolicies?sessionHash=${sessionHash}&permitId=${permitId}`,
      { headers },
    );
  }

  addInsurancePolicyService(params: any, sessionHash: string) {
    const headers = new HttpHeaders({
      responseType: 'text',
      'Content-Type': 'application/json-patch+json',
    });
    return this.http.post(
      this.api + `/api/insurancePolicies?sessionHash=${sessionHash}`,
      params.params,
      { headers },
    );
  }

  editInsurancePolicyService(params: any) {
    return this.http.put(
      this.api +
        `/api/insurancePolicies?sessionHash=${params.params.sessionHash}`,
      params.params,
      { responseType: 'text' },
    );
  }

  deleteInsurancePolicyService(params: any) {
    return this.http.delete(
      this.api + `/api/insurancePolicies/${params.insurancePolicyId}`,
      {
        params: params,
        responseType: 'text',
      },
    );
  }
}
